import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieConsentContext = createContext();

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }
  return context;
};

export const CookieConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState({
    necessary: true, // Always true, can't be disabled
    performance: false,
    functional: false,
    marketing: false,
  });

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const savedConsent = localStorage.getItem('cookie-consent');
    if (savedConsent) {
      try {
        const parsedConsent = JSON.parse(savedConsent);
        setConsent(parsedConsent);
        setShowBanner(false);
        // Apply cookie preferences
        applyCookiePreferences(parsedConsent);
      } catch (error) {
        // Bozuk/beklenmedik format (örn. bir tarayıcı eklentisinin yazdığı
        // düz string) - temizle ve banner'ı tekrar göster.
        console.error('Çerez tercihi okunurken hata:', error);
        localStorage.removeItem('cookie-consent');
        setShowBanner(true);
      }
    } else {
      setShowBanner(true);
    }
  }, []);

  const applyCookiePreferences = (preferences) => {
    // Apply cookie settings based on user preferences
    if (preferences.performance) {
      // Enable performance cookies (Google Analytics, etc.)
      // Implementation for performance cookies
    }
    
    if (preferences.functional) {
      // Enable functional cookies
      // Implementation for functional cookies
    }
    
    if (preferences.marketing) {
      // Enable marketing cookies (Google Ads, etc.)
      // Implementation for marketing cookies
    }
  };

  const acceptAll = () => {
    const allConsent = {
      necessary: true,
      performance: true,
      functional: true,
      marketing: true,
    };
    setConsent(allConsent);
    localStorage.setItem('cookie-consent', JSON.stringify(allConsent));
    setShowBanner(false);
    applyCookiePreferences(allConsent);
  };

  const rejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      performance: false,
      functional: false,
      marketing: false,
    };
    setConsent(onlyNecessary);
    localStorage.setItem('cookie-consent', JSON.stringify(onlyNecessary));
    setShowBanner(false);
    applyCookiePreferences(onlyNecessary);
  };

  const savePreferences = (preferences) => {
    const updatedConsent = {
      ...preferences,
      necessary: true, // Always keep necessary cookies
    };
    setConsent(updatedConsent);
    localStorage.setItem('cookie-consent', JSON.stringify(updatedConsent));
    setShowBanner(false);
    applyCookiePreferences(updatedConsent);
  };

  const openSettings = () => {
    setShowBanner(true);
  };

  const value = {
    consent,
    showBanner,
    setShowBanner,
    acceptAll,
    rejectAll,
    savePreferences,
    openSettings,
  };

  return (
    <CookieConsentContext.Provider value={value}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export default CookieConsentContext;

